{
  "INBOX": {
    "LIST": {
      "TITLE": "My Inbox",
      "DISPLAY_DROPDOWN": "Mostrar",
      "LOADING": "A obter notificações",
      "404": "Não há notificações ativas neste grupo.",
      "NO_NOTIFICATIONS": "Sem notificações",
      "NOTE": "Notificações de todas as caixas subscritas",
      "NO_MESSAGES_AVAILABLE": "Oops! Não foi possível importar mensagens",
      "SNOOZED_UNTIL": "Suspender até",
      "SNOOZED_UNTIL_TOMORROW": "Adiado até amanhã",
      "SNOOZED_UNTIL_NEXT_WEEK": "Adiada até a próxima semana"
    },
    "ACTION_HEADER": {
      "SNOOZE": "Suspender notificação",
      "DELETE": "Apagar notificação",
      "BACK": "Voltar"
    },
    "TYPES": {
      "CONVERSATION_MENTION": "Foi mencionado numa conversa",
      "CONVERSATION_CREATION": "Nova conversa criada",
      "CONVERSATION_ASSIGNMENT": "Foi-lhe atribuída uma conversa",
      "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Nova mensagem numa conversa que lhe está atribuída",
      "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Nova mensagem numa conversa em que participa",
      "SLA_MISSED_FIRST_RESPONSE": "SLA da primeira resposta não atingido na conversa",
      "SLA_MISSED_NEXT_RESPONSE": "SLA da próxima resposta não atingido na conversa",
      "SLA_MISSED_RESOLUTION": "SLA de resolução não atingido na conversa"
    },
    "TYPES_NEXT": {
      "CONVERSATION_MENTION": "Mentioned",
      "CONVERSATION_ASSIGNMENT": "Assigned to you",
      "CONVERSATION_CREATION": "New Conversation",
      "SLA_MISSED_FIRST_RESPONSE": "SLA breach",
      "SLA_MISSED_NEXT_RESPONSE": "SLA breach",
      "SLA_MISSED_RESOLUTION": "SLA breach",
      "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Nova mensagem",
      "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Nova mensagem",
      "SNOOZED_UNTIL": "Snoozed for {time}",
      "SNOOZED_ENDS": "Snooze ended",
      "UNASSIGNED_CONVERSATION_NEW_MESSAGE": "Nova mensagem"
    },
    "NO_CONTENT": "Sem conteúdo disponível",
    "PHONE_CALL_TYPES": {
      "OUTBOUND_CONNECTED": "Chamada efetuada - Atendida",
      "OUTBOUND_FAILED": "Chamada efetuada - Falhada",
      "INBOUND_MISSED": "Chamada recebida - Perdida",
      "INBOUND_UNANSWERED_MISSED": "Chamada recebida - Perdida sem resposta",
      "INBOUND_AGENT": "Chamada recebida - Atendida por agente",
      "INBOUND_IVR": "Chamada recebida - Atendida por IVR",
      "DEFAULT": "Chamada telefónica"
    },
    "MENU_ITEM": {
      "MARK_AS_READ": "Marcar como lida",
      "MARK_AS_UNREAD": "Marcar como não lida",
      "SNOOZE": "Adiar",
      "DELETE": "Excluir",
      "MARK_ALL_READ": "Marcar todas como lidas",
      "DELETE_ALL": "Excluir tudo",
      "DELETE_ALL_READ": "Excluir todas as lidas"
    },
    "DISPLAY_MENU": {
      "SORT": "Ordenar",
      "DISPLAY": "Mostrar :",
      "SORT_OPTIONS": {
        "NEWEST": "Recentes",
        "OLDEST": "Antigas",
        "PRIORITY": "Prioridade"
      },
      "DISPLAY_OPTIONS": {
        "SNOOZED": "Adiado",
        "READ": "Lida",
        "LABELS": "Etiquetas",
        "CONVERSATION_ID": "ID da conversa"
      }
    },
    "ALERTS": {
      "MARK_AS_READ": "Notificação marcada como lida",
      "MARK_AS_UNREAD": "Notificação marcada como não lida",
      "SNOOZE": "Notificação adiada",
      "DELETE": "Notificação excluída",
      "MARK_ALL_READ": "Todas as notificações marcadas como lidas",
      "DELETE_ALL": "Todas as notificações foram excluídas",
      "DELETE_ALL_READ": "Todas as notificações lidas foram excluídas"
    }
  }
}
